import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'services/redux/configureStore';

import type { BoardTaskStatus } from '../../../../common/types/task';

export const selectTasksCountByStatus = (status: BoardTaskStatus) =>
  createSelector(
    (state: RootState) => state.tasksBoard.tasks.countByStatus[status],
    (count) => count
  );
